import React from "react";
import {
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  Legend,
  Cell,
} from "recharts";
import JumboDemoCard from "@jumbo/components/JumboDemoCard";
import { Box, CircularProgress, Typography } from "@mui/material";
import {
  numberFormat,
  sortRowsByPerformancePriority,
} from "../../utils/utils";

const DatagridtableHeight = window.innerHeight - 135; //136

const COLORS = [
  "#1e88e5",
  "#e91e63",
  "#FF8C00",
  "#F44336",
  "#50B432",
  "#ED561B",
  "#DDDF00",
  "#24CBE5",
  "#64E572",
  "#FF9655",
  "#FFF263",
  "#6AF9C4",
];

const StraightAnglePieChart = ({
  title,
  reportingTabsData,
  action,
  tabLoaders,
  nameKeyLabel,
  preparePieChartLabels,
  showLegend = false,
}) => {
  const chartData =
    reportingTabsData &&
    reportingTabsData[action] &&
    reportingTabsData[action].data &&
    reportingTabsData[action].data.length
      ? sortRowsByPerformancePriority(
          (nameKeyLabel == "campaign_id" ||
            nameKeyLabel == "creative_id" ||
            nameKeyLabel == "ssp") &&
            preparePieChartLabels != undefined
            ? preparePieChartLabels(nameKeyLabel, reportingTabsData[action].data)
            : reportingTabsData[action].data
        ).slice(0, 10)
      : [];

  return (
    <JumboDemoCard
      title={title}
      wrapperSx={{
        pt: 0,
        backgroundColor: "background.paper",
        height: "300px",
      }}
      sx={{ margin: "3px" }}
    >
      {tabLoaders && tabLoaders.length && tabLoaders.indexOf(action) != -1 ? (
        <Box sx={{ position: "relative" }}>
          <CircularProgress />
        </Box>
      ) : chartData.length ? (
        showLegend ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "stretch",
              gap: 2,
              height: 300,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                flex: "0 0 42%",
                minWidth: 260,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ResponsiveContainer width="100%" height={260}>
                <PieChart width={100}>
                  <Pie
                    dataKey={action}
                    startAngle={360}
                    endAngle={0}
                    data={chartData}
                    outerRadius={92}
                    fill={"#1e88e5"}
                    nameKey={nameKeyLabel}
                    label={false}
                    labelLine={false}
                  >
                    {chartData.map((entry, index) => (
                      <Cell key={index} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip
                    labelStyle={{ color: "black" }}
                    itemStyle={{ color: "black" }}
                    cursor={false}
                    formatter={(value) => numberFormat(value)}
                  />
                </PieChart>
              </ResponsiveContainer>
            </Box>
            <Box
              sx={{
                flex: "1 1 auto",
                minWidth: 0,
                maxHeight: 260,
                overflowY: "auto",
                pr: 1,
              }}
            >
              {chartData.map((entry, index) => (
                <Box
                  key={`${action}-${entry?.[nameKeyLabel] || index}`}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                    mb: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: 12,
                      height: 12,
                      borderRadius: "2px",
                      backgroundColor: COLORS[index % COLORS.length],
                      mt: "4px",
                      flex: "0 0 auto",
                    }}
                  />
                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "0.85rem",
                        lineHeight: 1.3,
                        wordBreak: "break-word",
                      }}
                    >
                      {entry?.[nameKeyLabel] || "Unknown"}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: "text.secondary", fontSize: "0.75rem" }}
                    >
                      {numberFormat(entry?.[action] || 0)}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart width={100}>
              <Pie
                dataKey={action}
                startAngle={360}
                endAngle={0}
                data={chartData}
                outerRadius={100}
                fill={"#1e88e5"}
                nameKey={nameKeyLabel}
                label={{}}
              >
                {chartData.map((entry, index) => (
                  <Cell key={index} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip
                labelStyle={{ color: "black" }}
                itemStyle={{ color: "black" }}
                cursor={false}
                formatter={(value) => numberFormat(value)}
              />
            </PieChart>
          </ResponsiveContainer>
        )
      ) : (
        <Box sx={{ position: "relative" }}>No data available.</Box>
      )}
    </JumboDemoCard>
  );
};

export default StraightAnglePieChart;
